import * as React from 'react';
import { LightningSvg } from 'assets/multi-port-icons';
import { brandColors } from 'brandColors';

export const NotYetAvailable: React.FC<{ className?: string }> = (props) => {
  const { className } = props;
  return (
    <div className={`flex items-center space-x-1 ${className}`}>
      <LightningSvg fill={brandColors.colors.orange.DEFAULT} height="17px" />
      <h4 className="font-medium text-gray-900">Feature not yet available</h4>
    </div>
  );
};
NotYetAvailable.displayName = 'Badges.NotYetAvailable';
